import { render } from "./ClinicalTrialsManagement.vue?vue&type=template&id=46fcd6dc&scoped=true"
import script from "./ClinicalTrialsManagement.vue?vue&type=script&lang=js"
export * from "./ClinicalTrialsManagement.vue?vue&type=script&lang=js"

import "./ClinicalTrialsManagement.vue?vue&type=style&index=0&id=46fcd6dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fcd6dc"]])

export default __exports__